const customPoolField = [
  {id: 'name', name: '客户姓名', minWidth: 150, data: {fixed: 'left'}, isDefault: true, isFixed: true, isEvent: true, isDisableDrag: true},
  {id: 'contact_tel', name: '手机号码', minWidth: 130, isDefault: true, isFixed: true},
  {id: 'require_type_name', name: '购房类型', minWidth: 130, isDefault: true, isFixed: false},
  {id: 'level_name', name: '客户等级', minWidth: 110, isDefault: true, isFixed: false},
  {id: 'latest_stage_name', name: '客户状态', minWidth: 110, isDefault: true, isFixed: false},
  {id: 'admin_name', name: '归属人', minWidth: 120, isDefault: true, isFixed: false},
  {id: 'latest_follow_up_time', name: '最后跟进时间', minWidth: 180, data: {sortable: 'custom'}, isDefault: true, isFixed: false, analysis: 'time'},
  {id: 'latest_follow_up_content', name: '最后跟进内容', minWidth: 220, isDefault: true, isFixed: false},
  {id: 'all_source_name', name: '来源', minWidth: 220, isDefault: true, isFixed: false},
  {id: 'created_at', name: '创客时间', minWidth: 190, isDefault: true, isFixed: false, data: {sortable: 'custom'}},
  {id: 'create_type_name', name: '分配方式', minWidth: 150, isDefault: true, isFixed: false},
  {id: 'sign_up_house_names', name: '报名楼盘', minWidth: 220, isDefault: false, isFixed: false},
  {id: 'intention_project_names', name: '意向项目', minWidth: 220, isDefault: false, isFixed: false},
  {id: 'city_names', name: '意向区域', minWidth: 220, isDefault: false, isFixed: false},
  {id: 'helper_names', name: '协助人', minWidth: 150, isDefault: false, isFixed: false},
  {id: 'contact_name', name: '主联系人', minWidth: 150, isDefault: false, isFixed: false},
  {id: 'next_follow_up_time', name: '下次跟进时间', minWidth: 200, isDefault: false, isFixed: false, data: {sortable: 'custom'}, analysis: 'time'},
  {id: 'latest_distribution_time', name: '最近分配时间', minWidth: 200, isDefault: false, isFixed: false, data: {sortable: 'custom'}, analysis: 'time'},
  {id: 'qualifications_name', name: '购房资格', minWidth: 120, isDefault: false, isFixed: false},
  {id: 'creator_name', name: '创建人', minWidth: 150, isDefault: false, isFixed: false},
  {id: 'deal_project_names', name: '成交项目', minWidth: 220, isDefault: false, isFixed: false},
  {id: 'fall_message', name: '掉公客池提醒',minWidth: 190, isDefault: false, isFixed: false},
  {id: 'label_names', name: '意向标签',minWidth: 130, isDefault: false, isFixed: false},
  {id: 'is_tel_empty_name', name: '是否空号',minWidth: 100, isDefault: false, isFixed: false},
  {id: 'latest_thread_time_str', name: '进线时间',minWidth: 160, isDefault: false, isFixed: false, data: {sortable: 'custom'}},
  {id: 'contact_tel_location', name: '归属地', minWidth: 130},
  {id: 'remark', name: '备注', minWidth: 150},
]
// 公客池字段-【放入公客池原因放入页面展示逻辑】
const publicPoolField = [
  {id: 'name', name: '客户姓名', minWidth: 150, data: {fixed: 'left'}, isDefault: true, isFixed: true, isDisableDrag: true},
  {id: 'contact_tel', name: '手机号码', minWidth: 130, isDefault: true},
  {id: 'level_name', name: '客户等级', minWidth: 100, isDefault: true},
  {id: 'sign_up_house_names', name: '报名楼盘', minWidth: 190, isDefault: true},
  {id: 'intention_project_names', name: '意向项目', minWidth: 190, isDefault: true},
  {id: 'latest_public_repeat_sign_up_time_str', name: '进线时间', minWidth: 190, isDefault: true, data: {sortable: 'custom'}},
  {id: 'put_in_time', name: '放入公客池时间',minWidth: 190, analysis: 'time', isDefault: true, data: {sortable: 'custom'}},
  {id: 'put_in_content', name: '放入公客池原因',minWidth: 200, isDefault: true},
  {id: 'created_at', name: '创客时间',minWidth: 150, isDefault: true, data: {sortable: 'custom'}},
  {id: 'contact_name', name: '主联系人', minWidth: 130},
  {id: 'contact_tel_location', name: '归属地', minWidth: 130},
  {id: 'city_names', name: '意向区域', minWidth: 180},
  {id: 'latest_stage_name', name: '客户状态', minWidth: 110},
  {id: 'old_admin_name', name: '原归属人', minWidth: 130},
  {id: 'latest_follow_up_time', name: '最后跟进时间', minWidth: 180, analysis: 'time', data: {sortable: 'custom'}},
  {id: 'latest_follow_up_content', name: '最后跟进内容', minWidth: 220},
]
// 无效池字段
const invalidPoolField = [
  {id: 'name', name: '客户姓名', minWidth: 150, data: {fixed: 'left'}, isEvent: true, isDefault: true},
  {id: 'contact_name', name: '主联系人', minWidth: 130, isDefault: true},
  {id: 'contact_tel', name: '手机号码', minWidth: 130, isDefault: true},
  {id: 'level_name', name: '客户等级', minWidth: 100, isDefault: true},
  {id: 'intention_project_names', name: '意向楼盘', minWidth: 150, isDefault: true},
  {id: 'latest_stage_name', name: '客户状态', minWidth: 110, isDefault: true},
  {id: 'old_admin_name', name: '申请人', minWidth: 130, isDefault: true},
  {id: 'latest_follow_up_time', name: '最后跟进时间', minWidth: 180, isDefault: true, analysis: 'time'},
  {id: 'latest_follow_up_content', name: '最后跟进内容', minWidth: 220, isDefault: true},
  {id: 'put_in_time', name: '放入无效池时间',minWidth: 190, analysis: 'time', isDefault: true},
  {id: 'put_in_content', name: '放入无效池内容',minWidth: 220, isDefault: true},
  {id: 'contact_tel_location', name: '归属地', minWidth: 130, isDefault: true}
]
// 黑名单字段
const blackPoolField = [
  {id: 'name', name: '客户姓名', minWidth: 150, data: {fixed: 'left'}, isEvent: true, isDefault: true},
  {id: 'contact_name', name: '主联系人', minWidth: 130, isDefault: true},
  {id: 'contact_tel', name: '手机号码', minWidth: 130, isDefault: true},
  {id: 'level_name', name: '客户等级', minWidth: 100, isDefault: true},
  {id: 'intention_project_names', name: '意向楼盘', minWidth: 150, isDefault: true},
  {id: 'latest_stage_name', name: '客户状态', minWidth: 110, isDefault: true},
  {id: 'old_admin_name', name: '申请人', minWidth: 130, isDefault: true},
  {id: 'latest_follow_up_time', name: '最后跟进时间', minWidth: 180, isDefault: true, analysis: 'time'},
  {id: 'latest_follow_up_content', name: '最后跟进内容', minWidth: 220, isDefault: true},
  {id: 'put_in_time', name: '放入黑名单时间',minWidth: 190, analysis: 'time', isDefault: true},
  {id: 'put_in_content', name: '放入黑名单内容',minWidth: 220, isDefault: true}
]
// 项目列表字段
const projectListField = [
  {id: 'name', name: '项目', minWidth: 180, isDefault: true},
  {id: 'union_area', name: '区域', minWidth: 150, isDefault: true},
  {id: 'house_type_name', name: '物业类型', minWidth: 120, isDefault: true},
  {id: 'address', name: '项目位置', minWidth: 180, isDefault: true},
  {id: 'agency_time', name: '合作时间', minWidth: 180, isDefault: true},
  {id: 'coop_status_name', name: '合作状态', minWidth: 120, isDefault: true},
  {id: 'director', name: '拓盘负责人', minWidth: 120, isDefault: true},
  {id: 'updated_at', name: '更新时间', minWidth: 180, isDefault: true},
  {id: 'created_at', name: '创建时间', minWidth: 180, isDefault: true}
]
// 已处理任务字段
const dealedTaskField = [
  {id: 'title', name: '任务类型', minWidth: 150, isDefault: true},
  {id: 'to_name', name: '执行人', minWidth: 150, isDefault: true},
  {id: 'handle_status_name', name: '状态', minWidth: 150, isDefault: true},
  {id: 'select_deadline', name: '截止日期/提交日期', minWidth: 180, analysis: 'date', isDefault: true},
  {id: 'handle_time', name: '处理日期', minWidth: 150, analysis: 'date', isDefault: true}
]
// 商机列表字段
const bussinessListField = [
  {id: 'project_name', name: '项目名称', minWidth: 150, isDefault: true},
  {id: 'customer_name', name: '客户', minWidth: 150, isDefault: true},
  {id: 'contact_name', name: '主联系人', minWidth: 150, isDefault: true},
  {id: 'business_stage_name', name: '商机状态', minWidth: 150, isDefault: true},
  {id: 'contact_tel', name: '手机号码', minWidth: 150, isDefault: true},
  {id: 'admin_name', name: '归属人', minWidth: 150, isDefault: true},
  {id: 'latest_follow_up_time', name: '最后跟进时间', minWidth: 180, analysis: 'time', isDefault: true},
  {id: 'latest_follow_up_content', name: '最后跟进内容', minWidth: 200, isDefault: true},
  {id: 'creator_name', name: '创建人', minWidth: 150, isDefault: true},
  {id: 'created_at', name: '创建时间', minWidth: 180, isDefault: true}
]
// 订单列表字段
const orderListField = [
  {id: 'project_name', name: '项目名称', minWidth: 150, isDefault: true},
  {id: 'customer_name', name: '客户', minWidth: 150, isDefault: true},
  {id: 'order_stage_name', name: '订单状态', minWidth: 150, isDefault: true},
  {id: 'building', name: '楼栋', minWidth: 100, isDefault: true},
  {id: 'unit', name: '单元', minWidth: 100, isDefault: true},
  {id: 'room_num', name: '房号', minWidth: 100, isDefault: true},
  {id: 'subscription_amount', name: '认购金额（元）', analysis: 'number', minWidth: 160, isDefault: true, numFixed: 2},
  {id: 'room_total_amount', name: '房屋总价（元）', analysis: 'number', minWidth: 160, isDefault: true, numFixed: 2},
  {id: 'brokerage', name: '佣金（元）', minWidth: 160, analysis: 'number', isDefault: true, numFixed: 2},
  {id: 'discount_amount', name: '优惠返佣（元）', analysis: 'number', minWidth: 160, isDefault: true, numFixed: 2},
  {id: 'latest_follow_up_time', name: '最后跟进时间', minWidth: 180, analysis: 'time', isDefault: true},
  {id: 'created_at', name: '创建时间', minWidth: 180, isDefault: true},
  {id: 'creator_name', name: '创建人', minWidth: 130, isDefault: true}
]
// 操作记录字段
const logRecordField = [
  {id: 'admin_name', name: '姓名', minWidth: 130, isDefault: true},
  {id: 'admin_account', name: '手机号码', minWidth: 120, isDefault: true},
  {id: 'action', name: '动作', minWidth: 100, isDefault: true},
  {id: 'object', name: '操作对象', minWidth: 100, isDefault: true},
  {id: 'url', name: 'URL', minWidth: 200, isDefault: true},
  {id: 'ip', name: 'IP', minWidth: 120, isDefault: true},
  {id: 'created_at', name: '操作时间', minWidth: 150, isDefault: true},
]
// 公告管理字段
const noticeManagerField = [
  {id: 'content', name: '内容', minWidth: 200, isDefault: true},
  {id: 'dept_name', name: '接收部门', minWidth: 150, isDefault: true},
  {id: 'sender_admin_name', name: '发布人', minWidth: 120, isDefault: true},
  {id: 'has_been_sent_name', name: '状态', minWidth: 110, isDefault: true},
  {id: 'send_time', name: '发布时间', minWidth: 150, isDefault: true, analysis: 'time'},
  {id: 'created_at', name: '创建时间', minWidth: 150, isDefault: true}
]
// 待审核部门人员字段
const memberBeApproveField = [
  {id: 'admin_id', name: 'ID', minWidth: 60, isDefault: true},
  {id: 'name', name: '经纪人姓名', minWidth: 130, isDefault: true},
  {id: 'account', name: '手机号', minWidth: 110, isDefault: true},
  {id: 'join_type_text', name: '加入商户类型', minWidth: 150, isDefault: true},
  {id: 'join_created_at', name: '邀请/申请时间', minWidth: 150, isDefault: true, analysis: 'time'},
  {id: 'created_at', name: '自由经纪人注册时间', minWidth: 150, isDefault: true},
]
export {
  customPoolField,
  publicPoolField,
  invalidPoolField,
  blackPoolField,
  projectListField,
  dealedTaskField,
  bussinessListField,
  orderListField,
  logRecordField,
  noticeManagerField,
  memberBeApproveField,
}

export default {}
